meedy.factory('meedy.messagesModel', ['$rootScope', 'meedy.baseModel', 'meedy.messagesService',
    function($rootScope, baseModel, messagesService) {

        function MessageModel() {
            this.stompClient = undefined;
            this.newMessages = -1;

            var self = this;

            this.getMessages = function(criteria) {
                messagesService.getMessages(criteria).then(
                    function (dataPage) {
                        $rootScope.$broadcast(Event.MEEDY.MESSAGES.GET_MESSAGES.SUCCESS, dataPage);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.MESSAGES.GET_MESSAGES.ERROR, error);
                    }
                )
            };

            this.getById = function(id) {
                messagesService.getById(id).then(
                    function (dataPage) {
                        $rootScope.$broadcast(Event.MEEDY.MESSAGES.GET_BY_ID.SUCCESS, dataPage);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.MESSAGES.GET_BY_ID.ERROR, error);
                    }
                )
            };

            this.getUnreadMessages = function() {
                messagesService.getUnreadMessages().then(
                    function (dataPage) {
                        $rootScope.$broadcast(Event.MEEDY.MESSAGES.GET_UNREAD_MESSAGES.SUCCESS, dataPage);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.MESSAGES.GET_UNREAD_MESSAGES.ERROR, error);
                    }
                )
            };

        }

        return new MessageModel();
    }
]);
